import { useDispatch, useSelector } from "react-redux";
import { loadDetails } from "..";
import { useLoggedInUser } from "../../Auth";
import { IAppState } from "../../Common";

const useUserDetails = () => {
  const dispatch = useDispatch();
  const user = useLoggedInUser();
  const toReturn = useSelector((state: IAppState) => {
    const { userDetails, userDetailsLoadingState } = state.userList;
    return { userDetails, userDetailsLoadingState };
  });

  if (
    !toReturn.userDetailsLoadingState.isLoaded &&
    !toReturn.userDetailsLoadingState.isLoading &&
    !toReturn.userDetailsLoadingState.errored &&
    user
  ) {
    loadDetails()(dispatch);
  }

  return toReturn;
};

export default useUserDetails;
